
export const getPublicImage = (path: string, remote: boolean = true): string => {
    return remote ? `https://9d13d6a2792908d08ec893dbd712a4c2.r2.cloudflarestorage.com/${path}` : `/${path}`;
}
